import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Card, Button, Form, Select, Input, ColorPicker } from 'antd';
import { DeleteOutlined, HolderOutlined } from '@ant-design/icons';

const SortableCard = ({ id, children, ...props }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 100 : 0,
    marginBottom: '16px',
  };

  return (
      <div ref={setNodeRef} style={style} {...attributes}>
        <Card
            {...props}
            extra={
              <div style={{ display: 'flex', gap: '8px' }}>
                <Button
                    type="text"
                    icon={<HolderOutlined />}
                    {...listeners}
                    style={{ cursor: 'grab' }}
                />
                {props.actions}
              </div>
            }
        >
          {children}
        </Card>
      </div>
  );
};
export {SortableCard};